import { render } from "./CreateQuotation.vue?vue&type=template&id=dd0ca4ea&scoped=true"
import script from "./CreateQuotation.vue?vue&type=script&lang=js"
export * from "./CreateQuotation.vue?vue&type=script&lang=js"

import "./CreateQuotation.vue?vue&type=style&index=0&id=dd0ca4ea&scoped=true&lang=css"

import exportComponent from "D:\\MAMP\\htdocs\\electra\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd0ca4ea"]])

export default __exports__